import React from 'react';
import PageHero from '../../components/ui-shree/PageHero';
import VedicBiophysicsBanner from '../../components/Philosophy/VedicBiophysicsBanner';
import VedicBiophysics from '../../components/Philosophy/VedicBiophysics';
import ProtocolOfHarmony from '../../components/Philosophy/ProtocolOfHarmony';
import HarmonyPrinciple from '../../components/Philosophy/HarmonyPrinciple';
import ThreeKProtocol from '../../components/Philosophy/ThreeKProtocol';
import Luxury2030 from '../../components/Philosophy/Luxury2030';
import IntellectualRoots from '../../components/Philosophy/IntellectualRoots';

/**
 * /philosophy — The Manifesto, in three parts.
 *
 *   § I   The Sovereign Statement (Vedic Biophysics banner)
 *   § II  The Protocol of Harmony (cooperative chemistry + Biological Ceasefire)
 *   § III The Harmony Principle (analogical reasoning)
 *
 * Followed by the three operational doctrines (3K, Luxury 2030, Intellectual
 * Roots) that map the manifesto onto practice.
 */

const PhilosophyPage = () => (
  <div data-testid="philosophy-page">
    {/* § I — The Sovereign Statement */}
    <VedicBiophysicsBanner testId="philosophy-vedic-biophysics-banner" />

    {/* Short page hero for context-after-banner */}
    <PageHero
      overline="The Manifesto · The Atelier's Doctrine"
      title={<>Three sections. <em className="text-[#90B0BF]">One refusal.</em></>}
      subtitle="The scientific pillar, the cooperative protocol, and the method of analogical reasoning — read in order, the manifesto becomes a single sentence."
      testId="philosophy-hero"
    />

    {/* Vedic Biophysics — the four pillars (Pillar I: Signatures, II: Light, III: Systems, IV: Method) */}
    <VedicBiophysics testId="philosophy-vedic-biophysics" />

    {/* § II — The Protocol of Harmony (carries the Biological Ceasefire) */}
    <ProtocolOfHarmony testId="philosophy-protocol-of-harmony" />

    {/* § III — The Harmony Principle (analogical reasoning) */}
    <HarmonyPrinciple testId="philosophy-harmony-principle" />

    {/* Operational doctrines that follow from the manifesto */}
    <ThreeKProtocol testId="philosophy-three-k-protocol" />
    <Luxury2030 testId="philosophy-luxury-2030" />
    <IntellectualRoots testId="philosophy-intellectual-roots" />
  </div>
);

export default PhilosophyPage;
